import MultiSelectTag from './MultiSelectTag.component';
import MultiSelectTagTextMode from './displayMode/TextMode.component';

export { MultiSelectTagTextMode };
export default MultiSelectTag;
